/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AttachKeySetForm,
  AttachKeySetForm$Outbound,
  AttachKeySetForm$outboundSchema,
} from "../components/attachkeysetform.js";

export type AttachRemoteSessionClientKeySetSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type AttachRemoteSessionClientKeySetSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type AttachRemoteSessionClientKeySetSecurity = {
  option1?: AttachRemoteSessionClientKeySetSecurityOption1 | undefined;
  option2?: AttachRemoteSessionClientKeySetSecurityOption2 | undefined;
};

export type AttachRemoteSessionClientKeySetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  attachKeySetForm: AttachKeySetForm;
};

/** @internal */
export type AttachRemoteSessionClientKeySetSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const AttachRemoteSessionClientKeySetSecurityOption1$outboundSchema:
  z.ZodMiniType<
    AttachRemoteSessionClientKeySetSecurityOption1$Outbound,
    AttachRemoteSessionClientKeySetSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function attachRemoteSessionClientKeySetSecurityOption1ToJSON(
  attachRemoteSessionClientKeySetSecurityOption1:
    AttachRemoteSessionClientKeySetSecurityOption1,
): string {
  return JSON.stringify(
    AttachRemoteSessionClientKeySetSecurityOption1$outboundSchema.parse(
      attachRemoteSessionClientKeySetSecurityOption1,
    ),
  );
}

/** @internal */
export type AttachRemoteSessionClientKeySetSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const AttachRemoteSessionClientKeySetSecurityOption2$outboundSchema:
  z.ZodMiniType<
    AttachRemoteSessionClientKeySetSecurityOption2$Outbound,
    AttachRemoteSessionClientKeySetSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function attachRemoteSessionClientKeySetSecurityOption2ToJSON(
  attachRemoteSessionClientKeySetSecurityOption2:
    AttachRemoteSessionClientKeySetSecurityOption2,
): string {
  return JSON.stringify(
    AttachRemoteSessionClientKeySetSecurityOption2$outboundSchema.parse(
      attachRemoteSessionClientKeySetSecurityOption2,
    ),
  );
}

/** @internal */
export type AttachRemoteSessionClientKeySetSecurity$Outbound = {
  Option1?: AttachRemoteSessionClientKeySetSecurityOption1$Outbound | undefined;
  Option2?: AttachRemoteSessionClientKeySetSecurityOption2$Outbound | undefined;
};

/** @internal */
export const AttachRemoteSessionClientKeySetSecurity$outboundSchema:
  z.ZodMiniType<
    AttachRemoteSessionClientKeySetSecurity$Outbound,
    AttachRemoteSessionClientKeySetSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        AttachRemoteSessionClientKeySetSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        AttachRemoteSessionClientKeySetSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function attachRemoteSessionClientKeySetSecurityToJSON(
  attachRemoteSessionClientKeySetSecurity:
    AttachRemoteSessionClientKeySetSecurity,
): string {
  return JSON.stringify(
    AttachRemoteSessionClientKeySetSecurity$outboundSchema.parse(
      attachRemoteSessionClientKeySetSecurity,
    ),
  );
}

/** @internal */
export type AttachRemoteSessionClientKeySetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AttachKeySetForm: AttachKeySetForm$Outbound;
};

/** @internal */
export const AttachRemoteSessionClientKeySetRequest$outboundSchema:
  z.ZodMiniType<
    AttachRemoteSessionClientKeySetRequest$Outbound,
    AttachRemoteSessionClientKeySetRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      attachKeySetForm: AttachKeySetForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
        attachKeySetForm: "AttachKeySetForm",
      });
    }),
  );

export function attachRemoteSessionClientKeySetRequestToJSON(
  attachRemoteSessionClientKeySetRequest:
    AttachRemoteSessionClientKeySetRequest,
): string {
  return JSON.stringify(
    AttachRemoteSessionClientKeySetRequest$outboundSchema.parse(
      attachRemoteSessionClientKeySetRequest,
    ),
  );
}
